@if(showSidebar){
<div
  class="sidebar-container top-0 left-0 fixed h-screen flex flex-wrap items-center justify-between flex-col"
>
  <div class="logo">
    <a href="#">
      <img class="w-full" src="../../../assets/icon/logo.svg" alt="logo" />
    </a>
  </div>
  <div class="sidebar-menu fixed block">
    <ul>
      <li><a routerLink="about">About Me</a></li>
      <li><a routerLink="services">Services</a></li>
      <li><a routerLink="portfolio">Portfolio</a></li>
      <li><a routerLink="blog-first"> Blog</a></li>
      <li><a routerLink="contact">Contact</a></li>
    </ul>
  </div>
</div>
}
